import { Injectable } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';

import { DialogService } from './dialog.service';
import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { Constants } from '@usimweb/core/services';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Disclaimer {
  public dailogClosedListener: BehaviorSubject<any> = new BehaviorSubject<boolean>(false);

  constructor(private dialogService: DialogService, private cookieService: CookieService) {}

  private openDialog(text: string[], app: string) {
    this.dialogService.openToUDialog(InfoDialogComponent, 'Terms of Use', text).subscribe(() => {
      this.cookieService.set('aggredTOUConditions_' + app, String(true));
      this.dailogClosedListener.next(true);
    });
  }

  public project(app: string) {
    if (this.cookieService.get('aggredTOUConditions_' + app)) {
      this.dailogClosedListener.next(true);
      return;
    }

    const text: string[] = [];

    switch (app) {
      case 'molded':
        this.openDialog(Constants.Molded.PR_DISCLAIMER, app);
        return;
      case 'mapper':
        this.openDialog(Constants.Mapper.PR_DISCLAIMER, app);
        return;
      case 'vela':
        this.openDialog(Constants.Vela.PR_DISCLAIMER, app);
        return;
    }
  }

  public create() {
    const text: string[] = [];
    text.push(Constants.Vela.PR_CR_DISLAIMER);
    this.dialogService.openToUDialog(InfoDialogComponent, 'Terms of Use', text);
  }

  public version() {
    const text: string[] = [];
    text.push(Constants.Vela.SIM_DISCLAIMER);
    this.dialogService.openToUDialog(InfoDialogComponent, Constants.General.TOU, text);
  }

  public moldedVersion() {
    this.dialogService.openToUDialog(InfoDialogComponent, Constants.General.TOU, Constants.Molded.VS_DISCLAIMER_1);
  }

  public moldedChangeCAD() {
    this.dialogService.openToUDialog(InfoDialogComponent, Constants.General.TOU, Constants.Molded.CAD_DISCLAIMER_1);
  }
}
